import VisitModal from './VisitModal'
import useVisitModal from './hooks/useVisitModal'

export { useVisitModal }
export default VisitModal
